import { SocialPlatform } from '@mg/shared';

/**
 * Why a conversation cannot be answered from the inbox, or null when a reply can be sent.
 *
 * LinkedIn only lets approved partner apps comment AS a Page, and LinkedIn offers apps no direct
 * messages at all, so every LinkedIn conversation (a comment or a mention) is read-only: the
 * thread shows this note where the reply box would be, and the server refuses such a reply too.
 * Decided by platform alone; every other platform can be answered.
 */
export function replyBlockedReason(c: { platform: SocialPlatform }): string | null {
  if (c.platform === SocialPlatform.LINKEDIN) {
    return "Replies to LinkedIn comments and mentions can't be sent from here — LinkedIn only lets approved partner apps comment as a Page. Reply on LinkedIn instead.";
  }
  return null;
}
